import { all } from "redux-saga/effects";
import { mapperSaga } from "./mapperSaga/mapperSage";
import { basicConfigSaga } from "./basicconfig/basicConfigSaga";

export default function* rootSaga() {
  yield all([
    mapperSaga(),
    basicConfigSaga(),
    // Add other sagas here
  ]);
}
